import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { TokenStorage } from '@interfaces'
import { appEnv } from 'src/app/env'
import { Observable } from 'rxjs'

export const tokenInterceptor: HttpInterceptorFn = (
	request: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	const baseUrl = appEnv.backendApiUrl.replace(/\/+$/, '')
	const requestUrl = request.url.startsWith('/') ? request.url : `/${request.url}`
	const noTokenRequests = ['emailVerification', 'googleapis']
	const token: TokenStorage | null = JSON.parse(localStorage.getItem('token') ?? 'null')

	// Excepción para las traducciones
	if (request.url.includes('/assets/i18n/')) {
		return next(request)
	}

	// Peticiones sin token
	if (request.headers.get('X-No-Headers') === 'true' || noTokenRequests.some(r => request.url.includes(r))) {
		return next(request)
	}

	// Sobreescribimos la URL base
	request = request.clone({
		url: `${baseUrl}${requestUrl}`
	})

	if (token) {
		request = request.clone({
			setHeaders: {
				Authorization: `Bearer ${token.access_token}`
			}
		})
	}

	return next(request)
}
